<template>
  <v-row class="title-wrap">
    <v-col cols="12" class="icon-title"
      ><icon-work-day :width="22" :height="22" />{{ title }}</v-col
    >
    <v-col cols="12" class="pt-0 px-6 title-desc" v-if="showInfoMsg">
      <!-- 배우자 출산휴가 시 휴가사용기간-->
      <!-- <div class="sub-label">
          <div class="label-title">휴가 사용기간</div>
          <div class="label-date">2022-04-20 ~ 2022-10-20</div>
        </div> -->

      <!-- 가능일수  -->
      <v-chip label class="chip-desc" color="#E8F9ED" v-if="showRestCnt"
        ><span
          >현재 사용 가능한 휴가는 <strong>{{ GET_REST_CNT }}</strong
          >일 입니다</span
        ></v-chip
      ></v-col
    >
  </v-row>
</template>
<script>
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';
import { mapGetters } from 'vuex';
import applCdMixin from '@/mixins/applCdMixin.js';

export default {
  mixins: [applCdMixin],
  computed: {
    ...mapGetters('ELA', ['GET_REST_CNT', 'GET_GNT_CD']),
    showInfoMsg() {
      return this.showRestCnt;
    },
    title() {
      if (this.isAttend) {
        return '출/퇴근 변경일을 선택해주세요';
      } else {
        return '날짜를 선택해주세요.';
      }
    },
  },
  components: {
    IconWorkDay,
  },
};
</script>

<style>
/* 날짜 선택 하단 패딩 */
.title-desc {
  padding-bottom: 20px;
}
/* 배우자 출산 휴가 시 label */
.sub-label {
  margin-top: 22px;
  margin-bottom: 8px;
}
.sub-label .label-title {
  margin-bottom: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #505961;
}
.sub-label .label-date {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: -0.48px;
  color: #087ef7;
}
</style>
